export enum InputBorderType_Enum {
	'underlined',
	'rounded',
	'square',
	'flat'
}
